export const TRANSLATION_PATH = (route) => {
  return `components.application.integrations.deleteIntegrationModal.${route}`;
};
